import React from "react";
import PropTypes from "prop-types";
import { ButtonLink, ButtonContainer } from "./styles/button-styles";

const Button = (props) => {
  const {
    targetNew,
    buttonLink,
    id,
    disabled,
    buttonName,
    primary,
    secondary,
    secondaryWhite,
    tertiary,
    type,
    resetButtonFocus,
    onClickAction,
    dataTestId,
    noFocus,
    firstStep,
    textareaFocused,
    classes,
  } = props;

  let target;
  if (targetNew === true) {
    target = "_blank";
  } else {
    target = "_top";
  }

  let disabledButton;
  if (disabled === true) {
    disabledButton = true;
  } else {
    disabledButton = false;
  }

  let buttonType;
  if (primary === true) {
    buttonType = "primary";
  }
  if (secondary === true) {
    buttonType = "secondary";
  }
  if (tertiary === true) {
    buttonType = "tertiary";
  }
  if (secondaryWhite === true) {
    buttonType = "secondaryWhite";
  }

  return (
    <ButtonLink
      href={buttonLink}
      title=""
      target={target}
      firstStep={firstStep}
      className={classes}
    >
      <ButtonContainer
        resetButtonFocus={resetButtonFocus}
        buttonType={buttonType}
        data-disabled={disabledButton}
        onClick={onClickAction}
        type={type}
        id={id}
        noFocus={noFocus}
        textareaFocused={textareaFocused}
        data-test-id={dataTestId}
      >
        {buttonName}
      </ButtonContainer>
    </ButtonLink>
  );
};

Button.propTypes = {
  buttonLink: PropTypes.string,
  buttonName: PropTypes.string,
  targetNew: PropTypes.bool,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  secondaryWhite: PropTypes.bool,
  tertiary: PropTypes.bool,
  resetButtonFocus: PropTypes.bool,
  onClickAction: PropTypes.func,
  type: PropTypes.string,
  dataTestId: PropTypes.string,
  noFocus: PropTypes.bool,
  firstStep: PropTypes.bool,
  textareaFocused: PropTypes.bool,
  classes: PropTypes.string,
};

Button.defaultProps = {
  buttonLink: PropTypes.isNull,
  buttonName: PropTypes.isNull,
  targetNew: false,
  id: PropTypes.isNull,
  disabled: false,
  primary: false,
  secondary: false,
  secondaryWhite: false,
  tertiary: false,
  resetButtonFocus: false,
  onClickAction: PropTypes.isNull,
  type: PropTypes.isNull,
  dataTestId: PropTypes.isNull,
  noFocus: PropTypes.isNull,
  firstStep: false,
  textareaFocused: false,
  classes: PropTypes.isNull,
};

export default Button;
